module.exports = "<p>\n  li-chess-player <strong *ngIf=\"player\">{{ player.id }}</strong> works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /workspace/chess.arska.org/chess/src/app/profile/li-chess-player.component.html
// module id = ../../../../../src/app/profile/li-chess-player.component.html
// module chunks = main